// Accordions exist
if(jQuery('.accordion').length) {
	jQuery('.accordion__item__header').on('click', function() {
		jQuery(this).trigger('accordion_toggle');
	});
}

jQuery('.accordion__item__header').on('accordion_toggle', function(obj) {
	if(jQuery(this).closest('ul').attr('data-accordion-unique') === 'true') {
		jQuery('.accordion__item').not(jQuery(this).parent()).removeClass('open');
	}

	jQuery(this).parent().toggleClass('open');
});

